import {
    apiRequest,
    dmsGetFolderList,
    dmsUploadFile,
    dmsGenerateFolder
} from "../../../../services/adapters/DMS/DmsService"

class DetailRepository {

    fetchFolderList = async (query) => {
        return await apiRequest("get", dmsGetFolderList, {
            params: query
        }, true)
    }

    fetchUploadDocument = async (query) => {
        return await apiRequest("post", dmsUploadFile, {
            body: query
        }, true)
    }

    fetchGenerateFolder = async (query) => {
        return await apiRequest("post", dmsGenerateFolder, {
            body: query
        }, true)
    }
}

export default DetailRepository